import "./banner_candidate.css";
import BannerImg from "../../../../assets/imgs/mockups/candidate_banner.webp";
import PlayStore from "../../../../assets/icons/library/google-play.webp";
import AppleIcon from "../../../../assets/icons/library/apple.png";
import { WrapperComponent, StoreButton } from "../../../_imports";
import Links from "../../../../constants/links";

function BannerCandidate() {
    return (
        <section className="banner-candidate">
            <WrapperComponent>
                <div className="banner-cand-content">
                    <div className="banner-cand-info">
                        <h1 className="banner-cand-title">CANDIDATE-SE A VAGAS DA SUA REGIÃO!</h1>
                        <p className="banner-cand-description">
                            Somos a plataforma ideal para quem busca uma nova oportunidade ou o primeiro emprego, conectamos você às melhores oportunidades da sua região.
                            <br /><br />
                            Esqueça a entrega de currículos impressos. Na Tonalida, você se candidata a quantas vagas quiser de forma gratuita e acompanha todo o processo em tempo real pelo aplicativo.
                            <br /><br />
                            Nossa tecnologia trabalha por você a TonIA realiza sua entrevista de forma 100% online e automática, permitindo que você mostre seu potencial para diversas empresas sem sair de casa.
                        </p>
                        <div className="banner-cand-actions-wrapper">
                            <p className="download-subtitle">Baixe aqui:</p>
                            <div className="banner-cand-actions">
                                <StoreButton
                                    icon={PlayStore}
                                    storeName="Google Play"
                                    textTop="Disponível na"
                                    url={Links.appCandPlay}
                                    ariaLabel="Baixar aplicativo Tonalida para Candidatos na Google Play"
                                />
                                <StoreButton
                                    icon={AppleIcon}
                                    storeName="App Store"
                                    textTop="Disponível na"
                                    url={Links.appCandIos}
                                    ariaLabel="Baixar aplicativo Tonalida para Candidatos na App Store"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="banner-cand-visual">
                        <img
                            src={BannerImg}
                            alt="Aplicativo Tonalida para candidatos"
                            fetchPriority="high"
                            width="800"
                            height="800"
                        />
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default BannerCandidate;
